export default {
    paymentType: {
        cash: 'Cash',
        card: 'Card'
    },
    deliveryType: {
        delivery: 'Delivery',
        pickup: 'Pickup'
    },
    deliveryCities: {
        baku: {
            title: 'Bakı şəhəri',
            options: {
                binagadi: {
                    title: 'Binəqədi rayonu',
                    options: {
                        bilajari: 'Biləcəri qəsəbəsi',
                        binagadi: 'Binəqədi qəsəbəsi',
                        rasulzadeh: 'Rəsulzadə qəsəbəsi',
                        sulutapa: 'Sulutəpə qəsəbəsi',
                        xojasan: 'Xocəsən qəsəbəsi',
                        mik6: '6-cı mikrorayon',
                        mik7: '7-ci mikrorayon',
                        mik8: '8-ci mikrorayon',
                        mik9: '9-cu mikrorayon',
                    }
                },
                narimanov: {
                    title: 'Nərimanov rayonu',
                    options: {
                        bakmil: 'Bakmil metrosu',
                        ganjlik: 'Gənclik metrosu',
                        narimanov: 'Nərimanov metrosu',
                        ulduz: 'Ulduz metrosu'
                    }
                },
                nasimi: {
                    title: 'Nəsimi rayonu',
                    options: {
                        may28: '28 May metrosu',
                        november8: '8 Noyabr metrosu',
                        majami: 'Memar Əcəmi metrosu',
                        mik1: '1-ci mikrorayon',
                        mik2: '2-ci mikrorayon',
                        mik3: '3-cü mikrorayon',
                        mik4: '4-cü mikrorayon',
                        mik5: '5-ci mikrorayon',
                        kubinka: 'Kubinka'
                    }
                },
                nizami: {
                    title: 'Nizami rayonu',
                    options: {
                        keshla: 'Keşlə qəsəbəsi',
                        koroghlu: 'Koroğlu metrosu',
                        neftchilar: 'Neftçilər metrosu',
                        qaraqarayev: 'Qara Qarayev metrosu',
                        xalqlar: 'Xalqlar dostluğu metrosu',
                    }
                },
                pirallahi: 'Pirallahı rayonu',
                garadag: {
                    title: 'Qaradağ rayonu',
                    options: {
                        sahil: 'Sahil qəsəbəsi',
                        lokbatan: 'Lökbatan qəsəbəsi',
                        shubani: 'Şubanı qəsəbəsi',
                    }
                },
                sabunchu: {
                    title: 'Sabunçu rayonu',
                    options: {
                        bakikhanov: 'Bakıxanov qəsəbəsi',
                        balakhani: 'Balaxanı qəsəbəsi',
                        bilgah: 'Bilgəh qəsəbəsi',
                        kurdakhani: 'Kürdəxanı qəsəbəsi',
                        mastagha: 'Maştağa qəsəbəsi',
                        nardaran: 'Nardaran qəsəbəsi',
                        pirshagi: 'Pirşağı qəsəbəsi',
                        ramana: 'Ramana qəsəbəsi',
                        sabunchu: 'Sabunçu qəsəbəsi',
                        zabrat: 'Zabrat qəsəbəsi',
                    }
                },
                sabail: {
                    title: 'Səbail rayonu',
                    options: {
                        sahe20: '20-ci sahə qəsəbəsi',
                        badamdar: 'Badamdar qəsəbəsi',
                        bayil: 'Bayıl qəsəbəsi',
                        bibiheybet: 'Bibiheybət qəsəbəsi',
                        icharishahar: 'İçərişəhər metrosu',
                        sahil: 'Sahil metrosu',
                    }
                },
                surakhani: {
                    title: 'Suraxanı rayonu',
                    options: {
                        amirjan: 'Əmircan qəsəbəsi',
                        hovsan: 'Hövsan qəsəbəsi',
                        qarachukhur: 'Qaraçuxur qəsəbəsi',
                        surakhani: 'Suraxanı qəsəbəsi',
                        yenigunashli: 'Yeni Günəşli qəsəbəsi',
                        zigh: 'Zığ qəsəbəsi',
                    }
                },
                khatai: {
                    title: 'Xətai rayonu',
                    options: {
                        ahmadli: 'Əhmədli qəsəbəsi',
                        gunashli: 'Günəşli qəsəbəsi',
                        hazi: 'Həzi Aslanov qəsəbəsi',
                        nzs: 'NZS qəsəbəsi',
                        khatai: 'Xətai metrosu',
                    }
                },
                khazar: {
                    title: 'Xəzər rayonu',
                    options: {
                        bina: 'Binə qəsəbəsi',
                        buzovna: 'Buzovna qəsəbəsi',
                        mardakan: 'Mərdəkan qəsəbəsi',
                        qala: 'Qala qəsəbəsi',
                        shagan: 'Şağan qəsəbəsi',
                        shuvalan: 'Şüvəlan qəsəbəsi',
                        turkan: 'Türkan qəsəbəsi',
                        zagulba: 'Zaqulba qəsəbəsi',
                        zira: 'Zirə qəsəbəsi',
                    }
                },
                yasamal: {
                    title: 'Yasamal rayonu',
                    options: {
                        yanvar20: '20 Yanvar metrosu',
                        elmler: 'Elmlər Akademiyası metrosu',
                        inshaatcilar: 'İnşaatçılar metrosu',
                        nizami: 'Nizami metrosu',
                        yeniyasamal: 'Yeni Yasamal',
                    }
                },
            }
        },
        khirdalan: 'Xırdalan şəhəri',
        sumgayit: 'Sumqayıt şəhəri',
        absheron: {
            title: 'Abşeron rayonu',
            options: {
                fatmayi: 'Fatmayı qəsəbəsi',
                masazir: 'Masazır qəsəbəsi',
                mehdiabad: 'Mehdiabad qəsəbəsi',
                musviqabad: 'Müşviqabad qəsəbəsi',
                novkhanı: 'Novxanı qəsəbəsi',
            }
        }
    },
    feedbackType: {
        info: 'Information',
        comment: 'Suggestion or comment'
    },
    reviewScoreGrades: {
        g5: 'Excellent',
        g4: 'Very good',
        g3: 'Average',
        g2: 'Poor',
        g1: 'Terrible'
    }
}
